import React from 'react';

import { useSelector } from 'react-redux';

import RefCopyField from 'src/components/ref-label/src/ref-copy-field/ref-copy-field';
import { useIntl } from 'src/hooks/intl';
import { SourceTreeButton } from 'src/sections/repository/components/checkout-button';
import { getCurrentRepository } from 'src/selectors/repository-selectors';

import { messages } from './branch-page.i18n';
import * as styles from './branch-page.styled';

interface EmptyBranchProps {
  branchName: string;
}

export const EmptyBranch = ({ branchName }: EmptyBranchProps): JSX.Element => {
  const intl = useIntl();
  const repository = useSelector(getCurrentRepository);

  return (
    <>
      <h3>{intl.formatMessage(messages.checkoutBranch)}</h3>
      <styles.EmptyBranchHelpText>
        <p>{intl.formatMessage(messages.checkoutBranchHelpText)}</p>
      </styles.EmptyBranchHelpText>
      <RefCopyField refName={branchName} />
      {repository && (
        <SourceTreeButton
          refName={branchName}
          repository={repository}
          appearance="primary"
        />
      )}
    </>
  );
};
